module.exports = __webpack_public_path__ + "342305e176a24f76399354f932752e5c.png";